import React, { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { getBackendUrl } from '../utils/api';

const API = getBackendUrl();

const BookingCancel = () => {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('booking_id');

  useEffect(() => {
    // Optionally cancel the booking on the backend
    if (bookingId) {
      cancelBooking();
    }
  }, [bookingId]);

  const cancelBooking = async () => {
    try {
      await fetch(`${API}/booking/cancel/${bookingId}`, {
        method: 'POST'
      });
      // We don't need to handle the response - just release the slot
    } catch (error) {
      console.error('Error cancelling booking:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#1a1f16] flex items-center justify-center p-6">
      <div className="max-w-lg w-full bg-[#232921] rounded-lg p-8 border border-[#3d4a35] text-center">
        
        {/* Icon */}
        <div className="w-20 h-20 mx-auto mb-6 bg-[#3d4a35] rounded-full flex items-center justify-center">
          <svg className="w-10 h-10 text-[#8b9a7e]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        
        <h1 className="text-2xl font-bold text-[#c5bfa9] mb-4">
          BOOKING CANCELLED
        </h1>
        
        <p className="text-[#8b9a7e] mb-8">
          Your booking has been cancelled and no payment has been taken. 
          The spot has been released for other players.
        </p>
        
        <div className="space-y-4">
          <Link 
            to="/"
            className="block w-full py-3 bg-[#3d4a35] hover:bg-[#4a5d42] text-[#e8e4dc] font-semibold tracking-wider rounded-lg border border-[#5a6f4e] transition-all duration-300"
          >
            BROWSE EVENTS
          </Link>
          
          <p className="text-[#6b7a5e] text-sm">
            Changed your mind? You can always book again.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookingCancel;
